import React from 'react';
import { Container } from 'reactstrap';

const TrustIndicators: React.FC = () => {
  return (
    <section className="trust-section text-center py-5">
      <Container>
        <p className="fw-bold fs-4 mb-4">Trusted by Over 1,000 Businesses Worldwide</p>
        <div className="d-flex justify-content-center gap-5 flex-wrap trust-logos">
          <img
            src="https://placehold.co/160x90/cccccc/333333?text=Business+Logo+1&font=Inter"
            alt="Business Brand 1 Logo"
            className="img-fluid"
          />
          <img
            src="https://placehold.co/160x90/cccccc/333333?text=Business+Logo+2&font=Inter"
            alt="Business Brand 2 Logo"
            className="img-fluid"
          />
          <img
            src="https://placehold.co/160x90/cccccc/333333?text=Business+Logo+3&font=Inter"
            alt="Business Brand 3 Logo"
            className="img-fluid"
          />
          <img
            src="https://placehold.co/160x90/cccccc/333333?text=Business+Logo+4&font=Inter"
            alt="Business Brand 4 Logo"
            className="img-fluid"
          />
          <img
            src="https://placehold.co/160x90/cccccc/333333?text=Business+Logo+5&font=Inter"
            alt="Business Brand 5 Logo"
            className="img-fluid"
          />
        </div>
      </Container>
    </section>
  );
};

export default TrustIndicators;
